import React from 'react';

import Tool from 'components/tool/Tool';

const Section = ({ prefix, tools, name, slug, path }) => (
  <div className="main">
    <h4>
      {prefix ? `${prefix} ` : ''}
      {name}
    </h4>
    {tools?.[0] ? (
      <div className="tools">
        {tools.map(tool => {
          return (
            <Tool
              key={`category-tool-${tool.slug.current}`}
              logo={tool.logo}
              path={`${path}/${slug}/${tool.slug.current}`}
              name={tool.name}
              description={tool.description}
            />
          );
        })}
      </div>
    ) : (
      <p>It seems this category doesn&apos;t have tools yet.</p>
    )}
  </div>
);

export default Section;
